module.exports = __webpack_public_path__ + "img/icon-win2.31e3b59f.svg";